import styled from "styled-components";

export const EducationStyle = styled.section`
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    padding: 20px;
    background-color: rgb(1,154,203);
    @media (max-width: 700px) {
        height: 100vh;
        flex: 1 0 100vw;
        padding: 20px;
      }
    

    button {
        margin-bottom: 30px;
    }

    div {
        background-color: white;
        width: 50vw;
        border: 1px solid transparent;
        border-radius: 20px;
        text-align: center;
        padding: 10px;
        @media (max-width: 768px) {
            width: 95vw;
        }
        & h4 {
            text-transform: uppercase;
            font-weight: bolder;
            color: #121214
        }
        & p {
            font-size: clamp(0.9em, 0.9em + 1vw, 1.5em);
        }
    }
`